import { DOCUMENT } from '@angular/common';
import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import {
	applyEnvironmentFavicon,
	DEFAULT_FAVICON_HREFS,
	FaviconHrefs,
} from '../utils/favicon.util';

export function provideFavicon(hrefs: FaviconHrefs = DEFAULT_FAVICON_HREFS): EnvironmentProviders {
	return provideAppInitializer(() => {
		const document = inject(DOCUMENT);
		applyEnvironmentFavicon(document, document.location.hostname, hrefs);
	});
}
